import moment from "moment/moment";

export const PdfModal = ({ pdfPath, theme }) => {
    return (
        <div
            className="modal fade"
            id="pdfModal"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-xl modal-dialog-centered">
                <div
                    className="modal-content"
                    style={{
                        backgroundColor: theme === "dark" ? "#000000" : "",
                        color: theme === "dark" ? "#ffffff" : "",
                    }}
                >

                    <div className="modal-header">
                        <h5 className="modal-title">PDF Preview</h5>
                        <button
                            type="button"
                            className={`btn-close ${theme === "dark" ? "btn-close-white" : ""}`}
                            data-bs-dismiss="modal"
                        ></button>
                    </div>

                    <div className="modal-body p-0">
                        {pdfPath ? (
                            <iframe
                                src={pdfPath}
                                width="100%"
                                height="600px"
                                style={{
                                    border: "none",
                                    backgroundColor: theme === "dark" ? "#000000" : ""
                                }}
                                title="PDF"
                            />
                        ) : (
                            <div className="p-3 text-center">
                                No PDF Available
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
};

const formatNumber = (value) => {
    const number = Number(value);

    if (!Number.isFinite(number)) {
        return "--";
    }

    return number.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

const formatQuantity = (value) => {
    const number = Number(value);

    if (!Number.isFinite(number)) {
        return "--";
    }

    return number.toLocaleString("en-IN");
};

const formatDate = (value) => {
    if (!value) {
        return "--";
    }

    const date = moment(value, ["YYYY-MM-DD HH:mm:ss", moment.ISO_8601], true);

    if (!date.isValid()) {
        return "--";
    }

    return date.format("DD MMM, YYYY");
};

export const AllocationModal = ({ stock, theme }) => {
    const allocationList = Array.isArray(stock?.allocationList)
        ? stock.allocationList
        : [];
    const isDark = theme === "dark";

    return (
        <div
            className="modal fade"
            id="allocationModal"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div
                    className="modal-content border-0 rounded-0"
                    style={{
                        backgroundColor: isDark ? "#0A0A0B" : "#ffffff",
                        color: isDark ? "#ffffff" : "#404040",
                    }}
                >
                    <div className="modal-header border-0 px-4 pt-4 pb-2">
                        <h4 className="modal-title fw-normal mb-0">
                            {stock?.symbol || "Allocation"}
                        </h4>
                        <button
                            type="button"
                            className={`btn-close ${isDark ? "btn-close-white" : ""}`}
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>

                    <div className="modal-body px-4 pb-4">
                        <div
                            className={`border-top pt-3 ${isDark ? "border-secondary" : ""}`}
                        >
                            {/* <p className="text-muted mb-2">
                                Rows 1 - {allocationList.length} out of{" "}
                                {allocationList.length}
                            </p> */}

                            <div className="table-responsive">
                                <table
                                    className={`table mb-0 align-middle ${isDark ? "table-dark" : ""}`}
                                >
                                    <thead>
                                        <tr>
                                            <th
                                                className="fw-normal text-muted"
                                                style={{
                                                    backgroundColor: isDark ? "#111111" : "#f8f8fa",
                                                }}
                                            >
                                                Date
                                            </th>
                                            <th
                                                className="fw-normal text-muted"
                                                style={{
                                                    backgroundColor: isDark ? "#111111" : "#f8f8fa",
                                                }}
                                            >
                                                Quantity
                                            </th>
                                            <th
                                                className="fw-normal text-muted text-end"
                                                style={{
                                                    backgroundColor: isDark ? "#111111" : "#f8f8fa",
                                                }}
                                            >
                                                Entry Price
                                            </th>
                                            <th
                                                className="fw-normal text-muted text-end"
                                                style={{
                                                    backgroundColor: isDark ? "#111111" : "#f8f8fa",
                                                }}
                                            >
                                                Invested
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {allocationList.length > 0 ? (
                                            allocationList.map((allocation, index) => (
                                                <tr key={`${allocation.qty}-${allocation.entryPrice}-${index}`}>
                                                    <td>
                                                        {formatDate(allocation.createdAt)}
                                                    </td>
                                                    <td>
                                                        {formatQuantity(allocation.qty)}
                                                    </td>
                                                    <td className="text-end">
                                                        {formatNumber(allocation.entryPrice)}
                                                    </td>
                                                    <td className="text-end">
                                                        {formatNumber(allocation.invested)}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td className="text-center text-muted py-4" colSpan="4">
                                                    No allocation data available.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
